<div class="cz-page">
  @if (displayLoading) {
    <div
      class="d-flex flex-column align-items-center justify-content-center common-loading-container"
    >
      <div class="w-25 text-center">
        <img class="common-loading" src="assets/menu_loading.gif" alt="common loading" />
        <p class="common-loading-text">Loading customizations, please wait...</p>
      </div>
    </div>
  } @else if (unFilteredCustomizations.length > 0) {
    <!-- Search + actions toolbar -->
    <div class="cz-toolbar">
      <div class="cz-search" [class.cz-search-disabled]="customizations.length == 0">
        <i class="bx bx-search cz-search-icon"></i>
        <input
          type="text"
          class="cz-search-input"
          placeholder="Search Customization..."
          (input)="searchCustomization($event)"
        />
      </div>
      <button
        class="cz-new-btn"
        (click)="addNewCustomization()"
        [ngClass]="{
          'cz-disabled': isPosManagedProvider,
        }"
      >
        <i class="bx bx-plus"></i>
        New Customization
      </button>
    </div>

    <!-- Customizations table -->
    <div class="cz-table">
      <div class="cz-table-scroll">
        <div class="cz-table-header">
          <div class="cz-col-name">Customization Name</div>
          <div class="cz-col-source">Source</div>
          <div class="cz-col-selection">Selection Type</div>
          <div class="cz-col-actions">Actions</div>
        </div>

        <div class="cz-table-body">
          @for (customization of pagedCustomizations; track customization.id; let idx = $index) {
            <div
              class="cz-row"
              [class.cz-row-expanded]="activeAccordionIndex === idx"
              (click)="toggleAccordion(idx)"
              role="button"
              tabindex="0"
              (keydown.enter)="toggleAccordion(idx)"
            >
              <div class="cz-col-name">
                <div
                  class="cz-icon-container"
                  [class.cz-icon-container-expanded]="activeAccordionIndex === idx"
                >
                  <i class="bx bx-category"></i>
                </div>
                <div class="cz-name-group">
                  <p class="cz-name">{{ customization.name | titlecase }}</p>
                  @if (customization.description) {
                    <p class="cz-description">{{ customization.description }}</p>
                  }
                  @if (customization.remarks) {
                    <p class="cz-remarks">{{ customization.remarks }}</p>
                  }
                  @if (customization.is_customer_visible === false) {
                    <div class="cz-settings-tags">
                      <span class="cz-settings-tag cz-settings-tag-hidden">Hidden</span>
                    </div>
                  }
                </div>
              </div>
              <div class="cz-col-source">
                <img
                  class="cz-source-logo"
                  src="{{ customization.source_logo }}"
                  alt="{{ customization.source }}"
                />
              </div>
              <div class="cz-col-selection">
                <span
                  class="cz-selection-badge"
                  [class.cz-selection-badge-multi]="customization.is_multi_select"
                >
                  {{ selectionLabel(customization) }}
                </span>
              </div>
              <div class="cz-col-actions">
                <span
                  class="cz-action-btn"
                  [class.cz-action-active]="customization.is_customer_visible !== false"
                  title="{{
                    customization.is_customer_visible === false
                      ? 'Hidden from customers'
                      : 'Visible to customers'
                  }}"
                  (click)="$event.stopPropagation()"
                  (keydown.enter)="$event.stopPropagation()"
                  role="button"
                  tabindex="0"
                >
                  <i
                    class="bx"
                    [ngClass]="customization.is_customer_visible === false ? 'bx-hide' : 'bx-show'"
                  ></i>
                </span>
                <span
                  class="cz-action-btn cz-action-edit"
                  title="Edit"
                  (click)="$event.stopPropagation(); addNewCustomization(customization)"
                  (keydown.enter)="$event.stopPropagation(); addNewCustomization(customization)"
                  role="button"
                  tabindex="0"
                >
                  <i class="bx bx-edit-alt"></i>
                </span>
                <span
                  class="cz-action-btn cz-action-delete"
                  title="Delete"
                  [ngClass]="{
                    'cz-disabled': !customization.is_deletable || isPosManagedProvider,
                  }"
                  (click)="$event.stopPropagation(); deleteCustomizationConfirm(customization)"
                  (keydown.enter)="
                    $event.stopPropagation(); deleteCustomizationConfirm(customization)
                  "
                  role="button"
                  tabindex="0"
                >
                  <i class="bx bx-trash"></i>
                </span>
                <i
                  class="bx cz-chevron"
                  [ngClass]="activeAccordionIndex === idx ? 'bx-chevron-up' : 'bx-chevron-down'"
                ></i>
              </div>
            </div>

            @if (activeAccordionIndex === idx) {
              <div class="cz-expanded">
                <div class="cz-nesting-bar"></div>
                <div class="cz-options-grid">
                  @for (type of customization.types; track type.type_id) {
                    <div
                      class="cz-option-card"
                      [class.cz-option-out-of-stock]="type.in_stock === false"
                    >
                      <div class="cz-option-icon">
                        <i class="bx bx-purchase-tag-alt"></i>
                      </div>
                      <div class="cz-option-details">
                        <div class="cz-option-title-price">
                          <p class="cz-option-title">{{ type.value }}</p>
                          <p class="cz-option-price">{{ type.price | currency: 'USD' }}</p>
                        </div>
                        @if (type.description) {
                          <p class="cz-option-description">{{ type.description }}</p>
                        }
                        @if (type.in_stock === false) {
                          <span class="cz-tag cz-tag-out-of-stock">Out of stock</span>
                        } @else if (type.is_default) {
                          <span class="cz-tag cz-tag-default">Default</span>
                        }
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
          } @empty {
            <div class="cz-empty-search">No more searched data found</div>
          }
        </div>
      </div>

      <div class="cz-table-footer">
        <p class="cz-footer-text">{{ footerText }}</p>
        <div class="cz-pagination">
          <button
            class="cz-page-btn"
            [disabled]="currentPage <= 1"
            (click)="prevPage()"
            aria-label="Previous page"
          >
            <i class="bx bx-chevron-left"></i>
          </button>
          <p class="cz-page-label">Page {{ currentPage }} of {{ totalPages }}</p>
          <button
            class="cz-page-btn"
            [disabled]="currentPage >= totalPages"
            (click)="nextPage()"
            aria-label="Next page"
          >
            <i class="bx bx-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>
  } @else {
    <div
      class="d-flex flex-column align-items-center justify-content-center common-empty-container"
    >
      <img src="assets/no-orders-yet.svg" alt="No Customizations" class="common-empty-img mb-3" />
      <p class="common-empty-header">No Customizations</p>
      <p class="common-empty-sub-text">Create customizations to manage your menu.</p>
    </div>
  }
</div>
